import Navbar from './Navbar';
import { Link} from 'react-router-dom'

function Footer() {
    return (
        <footer className='footer__container' id="footer">
            <div className='container'>
                {/* <Navbar showContactButton={false} /> */}

            </div>
        </footer>
    );
}

export default Footer;
